import { useState, useEffect } from 'react'
import { useContainerWidth } from '@fs/zion-ui'

interface Props<T> {
  base: T
  tabletOverrides?: Record<string, unknown>
  phoneOverrides?: Record<string, unknown>
}

/**
 *
 * @param desktopValues The default values
 * @param tabletOverrides
 * @param mobileOverrides
 * @returns
 */
export default function useResponsiveValues<T>(responsiveObject?: Props<T>): T {
  const { base, tabletOverrides, phoneOverrides } = responsiveObject || {}
  const atWidth = useContainerWidth()
  const responsiveSize = atWidth({ default: 'mobile', md: 'tablet', xl: 'desktop' })
  const [currentSize, setCurrentSize] = useState<string>()
  const [values, setValues] = useState<T>(base || ({} as T))

  useEffect(() => {
    if (responsiveSize !== currentSize && base) {
      const newValues = Object.keys(base).reduce((acc, key) => {
        const value = base[key]
        const override =
          // eslint-disable-next-line no-nested-ternary
          responsiveSize === 'tablet'
            ? tabletOverrides?.[key]
            : responsiveSize === 'mobile'
              ? phoneOverrides?.[key]
              : null
        return { ...acc, [key]: override || value }
      }, {} as T)
      setValues(newValues)
      setCurrentSize(responsiveSize)
    }
  }, [responsiveSize, atWidth, base, tabletOverrides, phoneOverrides, currentSize])

  return values
}
